import bill from "./bill"
import ref_client from "./refClient";
import ref_partner from "./refPartner";

const def = { bill, ref_client, ref_partner };

export default def;